import React from 'react'
import Modal from 'react-bootstrap-modal'

const ReceiptModal = ({receiptId, onClose}) => {
  return (
    <Modal container={document.body} show={true} onHide={onClose} className='receipt-modal'>
      <Modal.Header closeButton>
        <Modal.Title>Receipt</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <iframe src={'/receipts/' + receiptId} />
      </Modal.Body>
    </Modal>
  )
}

export default ReceiptModal
